const STORAGE_KEY = "gbli.paymentClientSessionId";

/**
 * Returns the stable client session id for the current browser tab,
 * creating and persisting one on first call.
 *
 * The id is stored in sessionStorage so it survives modal open/close cycles
 * within the same tab but not across tabs or page reloads. The backend uses it
 * to reuse the reserved PolicyNumber + staging row when the PortalOne modal is
 * re-opened, preventing stale records.
 */
export function getOrCreatePaymentClientSessionId(): string | undefined {
  try {
    const existing = window.sessionStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const generated =
      window.crypto && typeof window.crypto.randomUUID === "function"
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.sessionStorage.setItem(STORAGE_KEY, generated);
    return generated;
  } catch {
    return undefined;
  }
}

/**
 * Removes the client session id from sessionStorage after a successful
 * payment so that a future purchase on the same tab gets a fresh PolicyNumber.
 */
export function clearPaymentClientSessionId(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage unavailable — nothing to clear
  }
}
